module.exports = __webpack_public_path__ + "img/houserules_preview.bccb6fc4.jpg";